import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/generalStyle.css";
import "./Dashboard.css";
import { useLanguage } from "../i18n/LanguageContext";

export default function Dashboard() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const cards = [
    {
      icon: "✍️",
      title: t("dashboard.cards.lyrics.title"),
      desc: t("dashboard.cards.lyrics.desc"),
      btn: t("dashboard.cards.lyrics.button"),
      to: "/app/crear-letra"
    },
    {
      icon: "💡",
      title: t("dashboard.cards.ideas.title"),
      desc: t("dashboard.cards.ideas.desc"),
      btn: t("dashboard.cards.ideas.button"),
      to: "/app/crear-cancion"
    },
    {
      icon: "🎼",
      title: t("dashboard.cards.withLyrics.title"),
      desc: t("dashboard.cards.withLyrics.desc"),
      btn: t("dashboard.cards.withLyrics.button"),
      to: "/app/crear-can-con-letra"
    },
    {
      icon: "🧠",
      title: t("dashboard.cards.wizard.title"),
      desc: t("dashboard.cards.wizard.desc"),
      btn: t("dashboard.cards.wizard.button"),
      to: "/app/create"
    }
  ];

  return (
    <div className="page">
      <div className="container">
        <div className="dash-header">
          <h1 className="h1">{t("dashboard.title")}</h1>
          <p className="p-muted" style={{ marginTop: 8 }}>
            {t("dashboard.subtitle")}
          </p>
        </div>

        <div className="dash-grid">
          {cards.map((c) => (
            <section key={c.to} className="dash-card">
              <div className="dash-card-top">
                <div className="dash-icon" aria-hidden>
                  {c.icon}
                </div>
                <div className="dash-text">
                  <h2 className="dash-title">{c.title}</h2>
                  <p className="dash-desc">{c.desc}</p>
                </div>
              </div>

              <div className="dash-actions">
                <button className="btn btn-primary" onClick={() => navigate(c.to)}>
                  {c.btn}
                </button>
              </div>
            </section>
          ))}
        </div>

                {/* Crear canción desde el chat */}
        <div className="dash-ctaChat">
          <div className="dash-ctaChat-left">
            <div className="dash-ctaChat-ic" aria-hidden>💬</div>

            <div className="dash-ctaChat-text">
              <div className="dash-ctaChat-title">
                {t("dashboard.chat.title")}
              </div>

              <div className="dash-ctaChat-desc">
                {t("dashboard.chat.desc")}
              </div>
            </div>
          </div>

          <div className="dash-ctaChat-right">
            <button className="btn btn-primary" onClick={() => navigate("/app/chat-support")}>
              {t("dashboard.chat.button")}
            </button>
          </div>
        </div>


        {/* Tip / ayuda */}
        <div className="dash-tip">
          <div className="dash-tip-icon" aria-hidden>✅</div>
          <div>
            <div className="dash-tip-title">{t("dashboard.tip.title")}</div>
            <div className="dash-tip-desc">{t("dashboard.tip.desc")}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
